import type { StoryIconShape } from './StoryCard.data';

type StoryCardIconDefinition = {
  clipRule?: 'evenodd';
  path: string;
  maskPosition?: string;
  viewBox: string;
  maskSize: string;
};

export const STORY_CARD_ICON_DEFINITIONS: Record<StoryIconShape, StoryCardIconDefinition> = {
  'slash-circle': {
    clipRule: 'evenodd',
    path: 'M0 1426.51C240.95 1667.46 631.608 1667.46 872.559 1426.51C1113.51 1185.56 1113.51 794.899 872.559 553.948L0 1426.51ZM1212.16 180.713C971.206 -60.2375 580.548 -60.2376 339.598 180.713C98.6473 421.663 98.6473 812.321 339.598 1053.27L1212.16 180.713Z',
    viewBox: '0 0 1213 1608',
    maskPosition: '68% 50%',
    maskSize: 'auto 180%',
  },
  'clover-1': {
    path: 'M447.033 270.266C409.577 255.247 368.731 246.904 325.913 246.904C145.915 246.904 0 392.902 0 573C0 753.098 145.915 899.098 325.911 899.098C368.729 899.098 409.575 890.752 447.031 875.736C473.514 1029.22 607.128 1146 768.087 1146C948.083 1146 1094 1000 1094 819.902C1094 721.193 1050.11 632.799 980.856 573C1050.11 513.201 1094 424.806 1094 326.098C1094 145.998 948.085 0 768.087 0C607.127 0 473.514 116.782 447.033 270.266Z',
    viewBox: '0 0 1094 1146',
    maskSize: 'auto 135%',
  },
  'halved-pair': {
    path: 'M417 0C647.303 0.000166288 834 186.697 834 417C834 647.303 647.303 834 417 834C186.697 834 0 647.303 0 417C0 186.697 186.697 0 417 0ZM836.575 18.7217C1055.36 20.1071 1232.28 197.89 1232.28 416.998C1232.28 636.965 1053.97 815.283 834 815.283L836.575 18.7217Z',
    viewBox: '0 0 1233 834',
    maskSize: 'auto 105%',
    maskPosition: '73% 50%',
  },
  pinwheel: {
    clipRule: 'evenodd',
    path: 'M1339.7 1335.4C1706.47 1337.73 2003.07 1635.77 2003.07 2003.09C2003.07 2371.84 1704.14 2670.78 1335.38 2670.78L1339.7 1335.4ZM1335.4 1331.09C1337.72 964.314 1635.76 667.707 2003.08 667.707C2371.84 667.707 2670.77 966.645 2670.77 1335.4L1335.4 1331.09ZM1335.38 1339.72C1333.06 1706.49 1035.01 2003.1 667.697 2003.1C298.939 2003.1 0.000921769 1704.16 0.000846242 1335.4L1335.38 1339.72ZM667.685 667.696C667.685 298.938 966.623 0.000253739 1335.38 0.00022137L1331.06 1335.38C964.291 1333.06 667.685 1035.01 667.685 667.696Z',
    viewBox: '0 0 2671 2671',
    maskPosition: '49% 50%',
    maskSize: 'auto 300%',
  },
  'clover-2': {
    path: 'M236.778 566.54C223.62 599.339 216.31 635.108 216.31 672.603C216.31 830.224 344.218 958 502 958C659.782 958 787.691 830.224 787.691 672.605C787.691 635.11 780.38 599.341 767.224 566.542C901.688 543.351 1004 426.347 1004 285.397C1004 127.778 876.092 0 718.309 0C631.831 0 554.389 38.4371 502 99.0785C449.611 38.4371 372.169 0 285.691 0C127.908 0 0 127.776 0 285.397C0 426.347 102.312 543.351 236.778 566.54Z',
    viewBox: '0 0 1004 958',
    maskPosition: '100% 0',
    maskSize: 'auto 125%',
  },
  'twin-circle': {
    path: 'M1444.9 0C1712.76 0 1929.9 217.142 1929.9 485C1929.9 752.858 1712.76 970 1444.9 970C1200.9 970 998.977 789.811 964.948 555.239C930.919 789.811 729.003 970 485 970C217.142 970 0 752.858 0 485C0 217.142 217.142 0 485 0C729.003 0.00020365 930.918 180.188 964.948 414.759C998.978 180.187 1200.9 0 1444.9 0Z',
    viewBox: '0 0 1930 970',
    maskPosition: '100% 50%',
    maskSize: 'auto 125%',
  },
  'double-stack': {
    path: 'M798.311 0.000941667C798.311 192.548 661.974 353.251 480.57 390.845L798.311 390.845C798.311 611.292 619.602 790 399.155 790C178.708 790 0 611.292 0 390.845L317.739 390.845C136.336 353.251 0 192.548 0 0.000976562L798.311 0.000941667Z',
    viewBox: '0 0 799 790',
    maskPosition: '100% 50%',
    maskSize: 'auto 105%',
  },
  'clover-3': {
    path: 'M355.501 215.081C325.715 203.129 293.232 196.489 259.181 196.489C116.039 196.489 0 312.676 0 456C0 599.324 116.039 715.512 259.179 715.512C293.23 715.512 325.713 708.871 355.5 696.921C376.56 819.064 482.816 912 610.819 912C753.96 912 870 795.813 870 652.487C870 573.934 835.094 503.588 780.023 456C835.094 408.411 870 338.066 870 259.512C870 116.187 753.961 0 610.819 0C482.816 0 376.56 92.9363 355.501 215.081Z',
    viewBox: '0 0 870 912',
    maskSize: 'auto 105%',
  },
  'horizontal-split': {
    clipRule: 'evenodd',
    path: 'M1085.82 400.32C1085.82 613.205 913.241 785.783 700.356 785.784C487.471 785.784 314.893 613.207 314.894 400.321L1085.82 400.32ZM-0.000237 385.465C0.000191886 172.579 172.578 0.00143779 385.463 0.000957651C598.349 0.000542251 770.926 172.578 770.926 385.463L-0.000237 385.465Z',
    viewBox: '0 0 1086 786',
    maskSize: 'auto 105%',
  },
};

function createStoryCardMaskUrl({ clipRule, path, viewBox }: StoryCardIconDefinition): string {
  const clipRuleAttribute = clipRule ? ` clip-rule="${clipRule}"` : '';

  return `url("data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${viewBox}"><path${clipRuleAttribute} d="${path}"/></svg>`,
  )}")`;
}

export const STORY_CARD_MASKS = Object.fromEntries(
  Object.entries(STORY_CARD_ICON_DEFINITIONS).map(([key, definition]) => [
    key,
    createStoryCardMaskUrl(definition),
  ]),
) as Record<StoryIconShape, string>;
